import React from 'react'

const DroppableItem = ({
  onDrop,
  allowDrop = true,
  mode, // 'standalone' | 'solo' | 'multi' | undefined (auto)
  className = 'dg-drop',
  children,
}) => {

  if (!allowDrop) {
    return <>{children}</>
  }

  const handleDragOver = (e) => {
    if (!allowDrop) return
    e.preventDefault() // REQUIRED
  }

  const handleDrop = (e, a) => {
    if (!allowDrop) return
    e.preventDefault()

    let payload = null
    try {
      payload = JSON.parse(e.dataTransfer.getData('text/plain'))
    } catch (_) { }

    onDrop?.(payload, e)
  }

  const dropProps = {
    className,
    onDragOver: handleDragOver,
    onDrop: handleDrop,
  }

  const injectProps = (child) => {
    if (!React.isValidElement(child)) return child

    return React.cloneElement(child, {
      className: `${className} ${child.props.className ?? ''}`,

      // 🔑 CAPTURE PHASE
      onDragOverCapture: (e) => {
        handleDragOver(e)
      },

      onDrop: (e) => {
        handleDrop(e)
      },
    })
  }


  // ---------- MODE RESOLUTION ----------
  const childArray = React.Children.toArray(children)
  const resolvedMode = mode ?? (childArray.length > 1 ? 'multi' : 'solo')

  // ---------- MODES ----------
  if (resolvedMode === 'standalone') {
    return (
      <div {...dropProps}>
        {children}
      </div>
    )
  }

  if (resolvedMode === 'multi') {
    return (
      <>
        {childArray.map(injectProps)}
      </>
    )
  }

  // solo (default)
  return injectProps(childArray[0])
}

export default DroppableItem
